module.exports = __webpack_public_path__ + "img/9.88bf6560.png";